export default __webpack_public_path__ + "static/Humayun-47b1c034aa310afb83a23f636207b11b.png";